var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container", staticStyle: { "padding-top": "0" } },
    [
      _c(
        "a-tabs",
        {
          attrs: { "default-active-key": _vm.tabKey },
          on: { change: _vm.handleTabChange },
        },
        _vm._l(_vm.tabPaneConfig, function (item) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.tab } },
            [_c(item.key, { tag: "component" })],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }